import { Check, Clock, MessageSquare } from 'lucide-react';
import { avatarFarbe, initialen, type AnfrageAntwort } from '../../lib/planung';
import './PlanungsChips.css';

type Groesse = 'xs' | 'sm' | 'md';

const MARKE_ICON: Record<AnfrageAntwort, typeof Check> = { passt: Check, kommentiert: MessageSquare, offen: Clock };

/**
 * Runder Kreis mit Initialen — die Farbe folgt dem Namen, bleibt also gleich.
 * Mit antwort trägt er unten rechts ein kleines Zeichen: Haken = „Passt so",
 * Sprechblase = kommentiert, Uhr = noch offen (nie nur Farbe).
 */
export function Avatar({ name, groesse = 'sm', antwort }: { name: string; groesse?: Groesse; antwort?: AnfrageAntwort }) {
  const Marke = antwort ? MARKE_ICON[antwort] : null;
  return (
    <span className={`pl-avatar pl-avatar--${groesse}`} style={{ background: avatarFarbe(name) }} title={name} aria-hidden="true">
      {initialen(name)}
      {Marke && antwort && (
        <span className={`pl-avatar-marke pl-avatar-marke--${antwort}`}>
          <Marke size={8} strokeWidth={3} aria-hidden="true" />
        </span>
      )}
    </span>
  );
}

/**
 * Mehrere Avatare überlappend, Rest als „+N". Mit antworten (gleiche
 * Reihenfolge wie namen) bekommt jeder sein Antwort-Zeichen; ohne Beschriftung
 * (beschriftung = false) übernimmt das umgebende Element die Ansage.
 */
export function AvatarStapel({ namen, max = 4, antworten, beschriftung = true }: {
  namen: string[]; max?: number; antworten?: AnfrageAntwort[]; beschriftung?: boolean;
}) {
  if (namen.length === 0) return null;
  const sichtbar = namen.slice(0, max);
  const rest = namen.length - sichtbar.length;
  return (
    <span
      className={`pl-stapel${antworten ? ' pl-stapel--marken' : ''}`}
      {...(beschriftung ? { role: 'img', 'aria-label': namen.join(', ') } : { 'aria-hidden': true })}
    >
      {sichtbar.map((n, i) => <Avatar key={`${n}-${i}`} name={n} groesse="xs" antwort={antworten?.[i]} />)}
      {rest > 0 && <span className="pl-avatar pl-avatar--xs pl-avatar--rest">+{rest}</span>}
    </span>
  );
}
